import { SimpleQueryStore, createSimpleQueryStoreEffects } from '@app/utils/SimpleQueryStore';

export const mccCodesSelectStore = new SimpleQueryStore('mccCodesSelect');

export const MccCodesSelectEffects = createSimpleQueryStoreEffects(
    mccCodesSelectStore,
    'getMccCodes'
);
